import {spotheroGet} from 'api';
import {ViewerResponse} from 'api/config/config.types';
import {sendSentryException} from 'utils/error-handling';

/**
 * Gets details about the viewer of the application, such as their country
 *
 * @see '/api/v1/control-panel/viewer/'
 */
export const getViewer = async () => {
    try {
        const response = await spotheroGet<ViewerResponse>(
            'control-panel/viewer/'
        );

        return response.data.data;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};
